import { useEffect } from 'react';
import { InterceptorsService } from '../services';

export const useInitInterceptors = () => {
  useEffect(() => {
    InterceptorsService.init();
  }, []);
};
